import pages from "./pages.js";
import layout from "./layout.js";
import components from "./components.js"
import settings from "./settings.js";
import information from "./information.js";
import docs from "./docs.js";

export default [pages, information, layout, docs, components, settings];